import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import FeaturesTierPicker from './FeaturesTierPicker';
import FeaturesTierMobilePicker from './FeaturesTierMobilePicker';
import FeaturesMobileTableHeader from './FeaturesMobileTableHeader';
import FeaturesTableHeader from './FeaturesTableHeader';
import { HeaderSection, ModalHeader, Table } from './FeatureStyledComponents';
import FeaturesLimitedTableRows from './FeaturesLimitedTableRows';
import FeaturesTableRows from './FeaturesTableRows';
import { getProductLevelFromApiNameString } from './FeaturesUtils';
import { debounce } from '../../utils'; // @ts-expect-error not migrated to TS

import ProductPageIcons from '../productPage/ProductPageIcons'; // @ts-expect-error not migrated to TS

import FooterMicrocopy from '../common/components/FooterMicrocopy';
import { productLineToHub } from 'self-service-api/constants/ProductLineToHub';
import UIModal from 'UIComponents/dialog/UIModal';
import UIImage from 'UIComponents/image/UIImage';
import H3 from 'UIComponents/elements/headings/H3';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import { FeaturesContext } from './FeaturesProvider';
const MODAL_WIDTH = 1200;
const HEADER_HEIGHT = 128;
const MODAL_TOP_MARGIN = 60;
const MODAL_BOTTOM_MARGIN = 47;

const FeaturesModal = ({
  productLine,
  defaultProductLevel,
  onCloseClick
}) => {
  const {
    highlightedProducts
  } = useContext(FeaturesContext);
  const [width, setWidth] = useState(window.innerWidth);
  const headerKeys = ['features', ...highlightedProducts.map(apiName => getProductLevelFromApiNameString(apiName).toLowerCase())];

  const getDefaultColumnIndex = () => {
    const productLevelIndex = defaultProductLevel ? headerKeys.slice(1).indexOf(defaultProductLevel.toLowerCase()) : 0;
    return Math.max(0, productLevelIndex);
  };

  const [activeColumn, setActiveColumn] = useState(getDefaultColumnIndex());
  useEffect(() => {
    const resizeWindow = debounce(() => setWidth(window.innerWidth), 250);
    window.addEventListener('resize', resizeWindow);
    return () => window.removeEventListener('resize', resizeWindow);
  }, []);
  const hubName = productLineToHub[productLine];
  const currentProduct = highlightedProducts[activeColumn];
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "conversational",
    width: MODAL_WIDTH,
    style: {
      overflow: 'hidden'
    },
    "data-selenium-id": `product-catalog-${hubName}`,
    children: [/*#__PURE__*/_jsx(HeaderSection, {
      children: /*#__PURE__*/_jsxs(ModalHeader, {
        children: [/*#__PURE__*/_jsx(UIImage, {
          className: "display-inline m-right-2 m-bottom-2",
          src: ProductPageIcons[hubName]
        }), /*#__PURE__*/_jsx(H3, {
          className: "display-inline",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `pricing-pages.hubs.${hubName}.name`
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: onCloseClick,
          "data-selenium-id": `product-catalog-close-${hubName}`
        })]
      })
    }), /*#__PURE__*/_jsxs(_Fragment, {
      children: [width <= 500 ? /*#__PURE__*/_jsx(FeaturesTierMobilePicker, {
        headerKeys: headerKeys,
        activeColumn: activeColumn,
        setActiveColumn: setActiveColumn
      }) : /*#__PURE__*/_jsx(FeaturesTierPicker, {
        activeColumn: activeColumn,
        headerKeys: headerKeys,
        setActiveColumn: setActiveColumn
      }), /*#__PURE__*/_jsxs("div", {
        children: [width <= 800 ? /*#__PURE__*/_jsx(FeaturesMobileTableHeader, {
          headerKeys: headerKeys,
          activeColumn: activeColumn
        }) : /*#__PURE__*/_jsx(FeaturesTableHeader, {
          headerKeys: headerKeys
        }), /*#__PURE__*/_jsxs(UIScrollContainer, {
          maxHeight: `calc(100vh - ${HEADER_HEIGHT + MODAL_TOP_MARGIN + MODAL_BOTTOM_MARGIN}px)`,
          scrollDirection: "vertical",
          children: [/*#__PURE__*/_jsx(Table, {
            children: /*#__PURE__*/_jsx("tbody", {
              children: width <= 800 ? /*#__PURE__*/_jsx(FeaturesLimitedTableRows, {
                activeColumn: activeColumn,
                currentProduct: currentProduct,
                showTooltip: false
              }) : /*#__PURE__*/_jsx(FeaturesTableRows, {})
            })
          }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
        })]
      })]
    })]
  });
};

export default FeaturesModal;